export const formatMedusaPrice = (price: number | null | undefined) => {
    let newPrice = 0

    if (price) {
        newPrice = price / 100
    }

    return newPrice.toFixed(2)
}
